import { GlobalFigures } from '../../../../common/model/output/market-sizes/types';
import { fetchOrThrow } from '../../common/fetchers/fetch-or-throw';

export async function fetchGlobalFiguresOrThrow(version: string) {
  return await fetchOrThrow<GlobalFigures>(`/scores/${version}/global-figures`);
}
